<template>
  <div id="private-root" class="text-center quest_topic">
    <div>
      <v-card style="text-align:center">
        <!-- <v-img :src="$store.state.server + '/admin/img/close.jpg'"></v-img> -->
        <!-- 修正破圖問題 -->
        <img v-bind:src="$store.state.server +'/admin/img/close.jpg'" style="max-width:100%;"/>
        <!-- local端測試 -->
        <!-- <img v-bind:src="$store.state.adminServer +'/img/close.jpg'" style="max-width:100%;"/> -->
        <p>此問卷尚未公開</p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#private-root {
  width: 100vw;
  // 垂直置中問題
  // height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
p{
  margin-bottom: 0;
}
</style>
